var $ = jQuery;

$(document).on('ready', function(){
    // $(document).on('click', '.select-search', function() {
    //     $('.location-select').trigger('click');
    // })
});